module.exports = __webpack_public_path__ + "src/img/zalando/img-iphones-reviews-wireframe.c2bc6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/zalando/img-iphones-reviews-wireframe.jpg
// module id = 262
// module chunks = 0